import { http } from "./http.js";

async function getUser(id) {
  const response = await http.get("/users/" + id);
  return {
    id: response.data.Id,
    title: response.data.Title,
    userName: response.data.Username,
    roles: response.data.Roles.map(role => {
      return {
        id: role.Id,
        title: role.Title,
      };
    }),
    avatar: response.data.Avatar,
    email: response.data.Email,
    client: response.data.Client
      ? {
        id: response.data.Client.Id,
        title: response.data.Client.Title,
      }
      : null,
    isRemoved: response.data.IsRemoved,
    removedDate: response.data.RemovedDate,
  };
}

async function changePassword(id, oldPassword, newPassword) {
  const response = await http.patch("/users/" + id + "/password", {
    oldPassword,
    newPassword,
  });
  return response;
}

async function createUser(user) {
  const response = await http.post("/users", user);
  return response;
}

async function updateUser(id, entity) {
  const response = await http.put(`users/${id}`, entity);
  return response;
}

async function updateAvatar(id, result) {
  const response = await http.patch(`users/${id}/avatar`, { data: result });
  return response;
}

async function removeAvatar(id) {
  const response = await http.patch(`users/${id}/avatar`, { data: "" });
  return response;
}

async function changeRemovedState(id, isRemoved) {
  const response = await http.patch(`users/${id}/rpc/change-removed-state`, {
    value: !isRemoved,
  });
  return response;
}

export {
  getUser,
  changePassword,
  createUser,
  updateUser,
  updateAvatar,
  removeAvatar,
  changeRemovedState,
};
